import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface GalleryImage {
  url: string;
  caption?: string;
}

export function useGalleryImages(category: "commercial" | "residential") {
  const [images, setImages] = useState<GalleryImage[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const { data, error } = await supabase
        .from("gallery_images")
        .select("image_url, caption, sort_order")
        .eq("category", category)
        .order("sort_order", { ascending: true });

      if (data) {
        setImages(data.map((row) => ({ url: row.image_url, caption: row.caption ?? undefined })));
      }
      if (error) console.error("Gallery load error:", error);
      setLoading(false);
    }
    load();
  }, [category]);

  return { images, loading };
}
